import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import { navigate } from "gatsby-plugin-intl";
import ReactPlayer from "react-player/vimeo";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledImageWrapper = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  position: relative;

  ${(props) =>
    props.link &&
    `
            &:hover {
                cursor: pointer;
                opacity: 0.9;
        }`}
`;

const StyledImg = styled.div`
  object-fit: cover;
`;

const StyledReactPlayer = styled(ReactPlayer)`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
  pointer-events: none;
`;

const StyledTitle = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 0.6rem;
`;

const StyledDescription = styled.div`
  margin-top: 0.2rem;
  font-size: 0.8rem;
  line-height: 1.1rem;
  opacity: 0.8;
`;

const ImageDescription = ({ asset, description, title, vimeoURL, link }) => {
  const handleClick = () => {
    if (link) {
      navigate(link);
    }
  };
  return (
    <StyledWrapper>
      <StyledImageWrapper link={link} onClick={() => handleClick()}>
        {vimeoURL && (
          <StyledReactPlayer
            light={false}
            controls={false}
            url={vimeoURL}
            playing={true}
            loop={true}
            muted={true}
            playsinline={true}
            width="100%"
            height="100%"
            style={{
              position: "absolute",
              top: "0",
              left: "0",
            }}
          />
        )}
        {asset &&
          (asset.ext === ".gif" ? (
            <img src={asset.url} alt="Image" />
          ) : (
            <GatsbyImage
              style={{ width: "100%", height: "100%" }}
              imgStyle={{ objectFit: "cover" }}
              image={getImage(asset.imageFile)}
              alt="Image"
            />
          ))}
      </StyledImageWrapper>
      {title && <StyledTitle>{title}</StyledTitle>}
      <StyledDescription>{description}</StyledDescription>
    </StyledWrapper>
  );
};

export default ImageDescription;
